import React from "react";

export default function PlayerFilterPanel({
  teams,
  homeNumbers,
  awayNumbers,
  onSelectPlayer,
  selectedPlayer,
  athletesWithTempo = [], // array de {side, number}
  teamNames,
}) {
  if (!teams || !teamNames)
    return <div className="text-xs text-gray-400">Carregando...</div>;
  if (
    !homeNumbers ||
    !awayNumbers ||
    homeNumbers.length === 0 ||
    awayNumbers.length === 0
  ) {
    return (
      <div className="text-xs text-red-500">
        Erro: homeNumbers e awayNumbers não podem ser vazios. Verifique o
        componente pai.
      </div>
    );
  }

  // Helper para extrair nome
  const getName = (ath) => ath.name || (ath.athlete && ath.athlete.name) || "";
  // Helper para extrair número
  const getNumber = (ath) =>
    ath.number || (ath.athlete && ath.athlete.number) || "";

  // Antes de filtrar titulares e reservas
  const validHomeNumbers = homeNumbers.filter(
    (num) =>
      !!num &&
      (teams.home || []).some((ath) => String(getNumber(ath)) === String(num))
  );
  const validAwayNumbers = awayNumbers.filter(
    (num) =>
      !!num &&
      (teams.away || []).some((ath) => String(getNumber(ath)) === String(num))
  );

  // Titulares na ordem do array
  const homeOnCourt = homeNumbers
    .map((num) =>
      (teams.home || []).find((ath) => String(getNumber(ath)) === String(num))
    )
    .filter(Boolean);
  const awayOnCourt = awayNumbers
    .map((num) =>
      (teams.away || []).find((ath) => String(getNumber(ath)) === String(num))
    )
    .filter(Boolean);
  // Reservas: todos que NÃO estão nos titulares (garantido pelo array de objetos)
  const homeOnCourtNumbers = homeOnCourt.map((ath) => String(getNumber(ath)));
  const awayOnCourtNumbers = awayOnCourt.map((ath) => String(getNumber(ath)));
  const homeReserves = (teams.home || []).filter(
    (ath) => !homeOnCourtNumbers.includes(String(getNumber(ath)))
  );
  const awayReserves = (teams.away || []).filter(
    (ath) => !awayOnCourtNumbers.includes(String(getNumber(ath)))
  );

  // Helper para saber se atleta tem tempo (apenas se o número bate com scout.cod[1,2] de jogada com tempo)
  const hasTempo = (side, number) =>
    athletesWithTempo?.some(
      (a) =>
        a.side === side && String(Number(a.number)) === String(Number(number))
    );

  const renderList = (list, side) =>
    list.map((ath) => {
      const number = String(getNumber(ath));
      const isSelected =
        selectedPlayer &&
        selectedPlayer.side === side &&
        String(selectedPlayer.number) === number;
      const tempo = hasTempo(side, number);
      return (
        <button
          key={number}
          className={`block w-full text-left px-0.5 py-0 text-[9px] truncate hover:bg-blue-100 hover:text-blue-700 rounded transition-all ${
            isSelected ? "bg-blue-200 text-blue-800 font-bold" : "text-gray-700"
          } ${tempo ? "font-bold" : ""}`}
          onClick={() => onSelectPlayer({ side, number })}
        >
          {number} - {getName(ath)}
        </button>
      );
    });

  return (
    <div
      className="flex gap-0 h-full text-[9px] min-w-[180px] max-w-[240px] font-normal overflow-y-auto"
      style={{ fontSize: 9 }}
    >
      {/* Home */}
      <div className="flex-1 flex flex-col h-full">
        <button
          className={`text-[9px] mb-0 font-semibold w-full text-left px-0.5 py-0 rounded hover:bg-blue-100 hover:text-blue-700 ${
            selectedPlayer &&
            selectedPlayer.side === "home" &&
            !selectedPlayer.number
              ? "bg-blue-200 text-blue-800"
              : "text-blue-700"
          }`}
          onClick={() => onSelectPlayer({ side: "home", number: null })}
        >
          {typeof teamNames?.home === "string"
            ? teamNames.home
            : teamNames?.home?.name || "Home"}
        </button>
        <div className="mb-0">{renderList(homeOnCourt, "home")}</div>
        {homeReserves.length > 0 && (
          <>
            <div className="border-b border-gray-300 my-0" />
            <div className="text-[9px] text-gray-400 mb-0">Reservas</div>
            <div>{renderList(homeReserves, "home")}</div>
          </>
        )}
      </div>
      {/* Away */}
      <div className="flex-1 flex flex-col h-full">
        <button
          className={`text-xs mb-1 font-semibold w-full text-left px-2 py-0.5 rounded hover:bg-red-100 hover:text-red-700 ${
            selectedPlayer &&
            selectedPlayer.side === "away" &&
            !selectedPlayer.number
              ? "bg-red-200 text-red-800"
              : "text-red-700"
          }`}
          onClick={() => onSelectPlayer({ side: "away", number: null })}
        >
          {typeof teamNames?.away === "string"
            ? teamNames.away
            : teamNames?.away?.name || "Away"}
        </button>
        <div className="mb-1">{renderList(awayOnCourt, "away")}</div>
        {awayReserves.length > 0 && (
          <>
            <div className="border-b border-gray-300 my-2" />
            <div className="text-[10px] text-gray-400 mb-1">Reservas</div>
            <div>{renderList(awayReserves, "away")}</div>
          </>
        )}
      </div>
    </div>
  );
}
